export default __webpack_public_path__ + "static/media/fundo1.858d6b70.jpg";